// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rHB1","rootNoMargin":"styles_rootNoMargin__1QtvX"};